import { html } from "lit-element";
import { SharedStyles } from "../../../../styles/shared-styles";
import { StatefulModule } from "../../ModuleBase/ModuleMetadata";
import '../../../../elements/color-picker.js';

export class DrawTagsAndLabelsModule extends StatefulModule {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e));
		this.fireOnDraw();
	}

	Draw(
		pointer,
		color = this.color,
		t = this.text,
		value = this.value,
		selectable = false
	) {
		let rect = new fabric.Rect({
			width: 46,
			height: 16,
			fill: color,
			stroke: "#000",
			strokeWidth: 1,
			originX: 0,
			originY: 0
		});
		let text = new fabric.Text(value, {
			originX: 0,
			originY: 0,
			top: 1.5,
			left: 19,
			fontSize: 13,
			fontFamily: "Arial"
		});
		let text1 = new fabric.Text(t, {
			originX: 0,
			originY: 0,
			top: 1,
			left: 55,
			fontSize: 15,
			fontFamily: "Arial"
		});

		let group = new fabric.Group([rect, text, text1], {
			top: pointer.y,
			left: pointer.x,
			hasBorders: true,
			hasControls: true,
			selectable: selectable
		});

		this.addMetadata(group, { color, value, label: t });
		this.canvas.add(group);
		this.canvas.renderAll();
	}

	render() {
		return html`
            ${SharedStyles}
            <style>
                :host {
                    height: 100%;
                    width: 200px;
                    position: relative;
                    right: 0px;
                    background-color: inherit;
                   
                }

                label {
                    display: block;
                    border: 3px solid transparent;
                    fill: gray;
                    stroke: gray;
                    cursor: pointer;
                    padding: 3px;
                    width: 100%;
                }

                label[selected] {
                   background-color:var(--primary-color);
                }

                .tag {
                    display: inline-block;
                    color: black;
                }

                label div {
                    border: solid 1px black;
                    height: 25px;
                    width: 50px;
                    text-align: center;
                }

                .contextMenu {
                    width: 150px !important;
                }
            </style>

            <label>
                <div class="tag" style="background-color: ${this.color}">
                    ${this.value}
                </div>
                ${this.text}   
            </label>    
        `;
	}

	RenderSettings(obj, closeFunc) {
		const currentSettings = obj.moduleState;
		let tempNumber = currentSettings.value;
		let tempLabel = currentSettings.label;
		let tempColor = currentSettings.color

		const applyFunc = () => {
			this.applyNewSettings(obj, tempNumber, tempLabel, tempColor);
			closeFunc();
		};

		return html`
            <style>
                .title {
                    font-size: x-large;    
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .button-box {
                    display: flex;
                    margin-top: 20px;
                }
                        .cPick{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: var(--secondary-color-variant1);
                }
            </style>
            <div class="title">Tag settings</div>    
            <div> 
                <text-box type="text" label="Tag" 
                    @change="${e => (tempNumber = e.currentTarget.value)}"
                    .value="${currentSettings.value}"></text-box>
                <text-box type="text" label="Label"
                    @change="${e => (tempLabel = e.currentTarget.value)}"
                    .value="${currentSettings.label}"></text-box>
                <div class="cPick">
                    <label for="bColor">Background color</label>
                     <color-picker id="tColor" name="lColor" .value="${tempColor}" @change="${(e) => tempColor = e.detail}" ></color-picker>
				
            </div>
            <div class="button-box">
                <mwc-button @click="${closeFunc}" label="Close"></mwc-button>
                <mwc-button @click="${applyFunc}" label="Apply"></mwc-button>
            </div>`;
	}

	applyNewSettings(obj, value, label, color) {
		this.Draw({ x: obj.left, y: obj.top }, color, label, value, true)
		this.canvas.remove(obj);
		let newObj = this.canvas._objects[this.canvas._objects.length - 1]
		newObj.set({ angle: obj.angle, scaleX: obj.scaleX, scaleY: obj.scaleY })
		this.addMetadata(newObj, { color: color, value: value, label: label });
		this.canvas.setActiveObject(newObj);
		this.canvas.trigger("object:modified", { newObj });
	}

	constructor(canvas, color, value, text) {
		super();
		this.canvas = canvas;
		this.color = color;
		this.value = value;
		this.text = text;
	}
}

window.customElements.define("inspx-draw-tags-lables", DrawTagsAndLabelsModule);
